// ── Constants ─────────────────────────────────────────────────────────────────

export const AVATAR_COLORS = [
  "bg-blue-500", "bg-emerald-500", "bg-purple-500", "bg-orange-500",
  "bg-pink-500", "bg-teal-500", "bg-indigo-500", "bg-rose-500",
  "bg-cyan-500", "bg-amber-500",
];

// WhatsApp's exact chat background — #efeae2 base with the official faint pattern overlay
export const WA_BACKGROUND = {
  backgroundColor: "#efeae2",
  backgroundImage: `url("data:image/svg+xml,%3Csvg width='304' height='250' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='p' width='304' height='250' patternUnits='userSpaceOnUse'%3E%3Cpath fill='%23d9d4ca' fill-opacity='0.4' d='M4 0h4L0 4V0zm8 0h4L4 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm8 0h4l-8 8V4zm4 0l-8 8V4l4-4zm-152 8l-8 8V12l4-4zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm8 0l-8 8V12zm4 0l-4 4v-4z'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='304' height='250' fill='url(%23p)'/%3E%3C/svg%3E")`,
};

export const STATUS_LABEL = {
  completed: "Completed",
  sending:   "Sending…",
  failed:    "Failed",
  pending:   "Pending",
};

export const STATUS_BADGE_CLASS = {
  completed: "bg-green-100 text-green-600",
  sending:   "bg-blue-100 text-blue-500",
  failed:    "bg-red-100 text-red-500",
  pending:   "bg-yellow-100 text-yellow-600",
};

// ── Small helpers ─────────────────────────────────────────────────────────────

export const pct = (a, b) => (b > 0 ? Math.round((a / b) * 100) : 0);

export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const diffDays = Math.floor((new Date() - d) / 86400000);
  if (diffDays === 0) return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7)  return d.toLocaleDateString([], { weekday: "short" });
  return d.toLocaleDateString([], { day: "numeric", month: "short" });
};

export const CATEGORY_COLOR = {
  MARKETING: "bg-purple-100 text-purple-700",
  UTILITY: "bg-blue-100 text-blue-700",
  AUTHENTICATION: "bg-orange-100 text-orange-700",
};
export const catColor = (c = "") => CATEGORY_COLOR[c.toUpperCase()] || "bg-gray-100 text-gray-600";
